/*
 * Copyright (c) 2020 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from "@angular/core";
import {Observable, ReplaySubject} from "rxjs";

@Injectable()
export class TermsAndConditionsRequestService {

  private termsAndConditionsRequestSubject: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(){
    this.emitTermsAndConditionsRequest();
  }

  getTermsAndConditionsRequest(): Observable<boolean>{
    return this.termsAndConditionsRequestSubject.asObservable();
  }

  emitTermsAndConditionsRequest(){
    this.termsAndConditionsRequestSubject.next(true);
  }

  unsubscribe(){
    this.termsAndConditionsRequestSubject.next(false);
  }
}
